

import { useCallback, useState, useContext, useEffect } from "react";
import { getOrganizationDesignation,addOrganizationDesignation,deleteOrganizationDesignation } from "./Services/AdvanceSettingService";
import { TostMsg } from "../../../App";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";
import { debounce } from "lodash";
import { InputText } from "primereact/inputtext";
import { useParams } from "react-router-dom/cjs/react-router-dom";

const OrgDesignationSetting = () => {
  const [columns, setColumns] = useState(["Designation", "Description"]);
  const [rows, setRows] = useState([{}]);
  const [editIndex, setEditIndex] = useState(null);
  const [orgDesignationList,setOrgDesignationList] = useState([]);
  const defaultImage = "/images/placeholder_profile.png";
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const [orgDepartId, setOrgDepartId] = useState(null);
  const [Isloading, setIsloading] = useState(false);
  let toster = useContext(TostMsg);
  const {GUID} = useParams();
  const [errors, setErrors] = useState({});
  const [data, setData] = useState({
    Designation: "",
    DesignationDescription: "",
  });
    let SearchValue = "";


  useEffect(() => {
    GetOrgDesignations();
  }, []);

  const validateOrgDesignation = (data, index) => {
    const newErrors = {};
    newErrors[`${index}-Designation`] =
      !data.Designation || data.Designation.trim() === ""
        ? "Designation is required"
        : undefined;
    newErrors[`${index}-DesignationDescription`] =
      !data.DesignationDescription || data.DesignationDescription.trim() === ""
        ? "Designation Description is required"
        : undefined;    
    setErrors((prev) => ({ ...prev, ...newErrors }));
    const isValid = Object.values(newErrors).every(
      (error) => error === undefined
    );
    return isValid;
  };

  async function GetOrgDesignations() {
    setIsloading(true);    
    try {
      let responce = await getOrganizationDesignation({});
      setOrgDesignationList(responce?.Data);
    } catch (err) {
      toster.current.error(ERROR_LIST.DefaultError);
    } finally {
      setIsloading(false);
    }
  }

  const handleAddRow = () => {
    setOrgDesignationList([
      ...orgDesignationList,
      { Designation: "", DesignationDescription: ""},
    ]);
    setEditIndex(orgDesignationList.length); // enter edit mode for new row
  };

  const handleRemoveRow = () => {
    setRows(rows.slice(0, -1));
  };

  const handleRemoveSpecificRow = (rowIdx) => () => {
    const updatedRows = rows.filter((_, idx) => idx !== rowIdx);
    setRows(updatedRows);
  };

  const handleChange = (rowIdx, colName) => (e) => {
  const { value } = e.target;
  setOrgDesignationList(prevList => {
    const newList = prevList.map((item, idx) =>
      idx === rowIdx ? { ...item, [colName]: value } : item
    );
    return newList;
  });
  setData(prev => ({ ...prev, [colName]: value }));
  validateOrgDesignation({ ...orgDesignationList[rowIdx], [colName]: value }, rowIdx);
};

  const cancelOrgWfh = () => {
  GetOrgDesignations();
  setOrgDesignationList(prevList => {
    setEditIndex(null);
    const len = prevList.length;
    if (len === 0) return prevList;

    const lastItem = prevList[len - 1];
    const isEmpty = lastItem &&
      !lastItem.Designation &&
      !lastItem.DesignationDescription ;
    if (isEmpty) {
      return prevList.slice(0, -1);
    }
    return prevList;
  });
}

 
  async function addOrgDesignations(index, data) {
    const body = 
    {
  Id: data?.Id || 0,
  GUID:GUID ,
  IsActive: true,
  OrgId: userDetails?.OrgId,
  Designation: data.Designation,
  DesignationDescription: data.DesignationDescription,
};
    try {
      await addOrganizationDesignation(body);
      if (orgDepartId) {
        alert('Org Leave Updated');
      } else {
        alert('Org Leave Added');
      }
      setOrgDesignationList([]);
      setEditIndex(null);
      GetOrgDesignations();
      setIsloading(false);
    } catch (err) {
      setIsloading(false);
    }
  }

  const handleImageError = useCallback((event) => {
    event.target.src = defaultImage;
  }, []);

  const handleEditClick = (index) => {
    setEditIndex(index);
  };

  const handleDepartIstDelete = (Id) => {
    setOrgDepartId(Id);
  };

   async function DeleteOrgDesignation() { 
      setIsloading(true);
      if (orgDepartId) {
        let body = {
          Id: orgDepartId,
        };
        try {
          let orgDepartDeleteList = await deleteOrganizationDesignation(body);
          if (orgDepartDeleteList) {
            setIsloading(false);
            GetOrgDesignations();
          }
        } catch (error) {
          toster.current.error(ERROR_LIST.DefaultError);
        }
      }
    }

  const handleInputChange = (event) => {
    debouncedSearch(event.target.value);
  };

  const debouncedSearch = useCallback(
    debounce((value) => {
      SearchValue = value;
      let filteredList = orgDesignationList.filter((orgLoc) =>
        orgLoc.Designation?.toLowerCase().includes(SearchValue?.toLowerCase())
      );
      if (SearchValue != "") {
        setOrgDesignationList(filteredList);
      } else {
        GetOrgDesignations();
      }
    }, 800),
    [orgDesignationList]
  );

  return (
    <div className="setting-detail-list">
      <div className="detail award-detail">
        <div className="input-group search-area2 d-xl-inline-flex mb-3 me-4">
        </div>
        <div className="title-text">
          <h3>Desginations Types ({orgDesignationList?.length})</h3>
          <div className="d-flex">
          <InputText
            name="requestTitle"
            className="form-control search-grpname me-2"
            onChange={handleInputChange}
            placeholder="Search"
          />
          {!editIndex && (
            <button
              className="addaward-btn"
              data-toggle="tooltip"
              data-placement="top"
              title=""
              data-bs-original-title=""
              fdprocessedid="izng1j"
              onClick={handleAddRow}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="currentColor"
                className="bi bi-plus"
                viewBox="0 0 16 16"
              >
                <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"></path>
              </svg>
              Desgination
            </button>
          )}
          </div>
        </div>
        <div className="col-md-12 column">
          <table className="table table-bordered table-hover" id="tab_logic">
            <thead>
              <tr>
                {columns.map((colName, colIdx) => (
                  <th key={colIdx} className="text-left">
                    {colName}
                  </th>
                ))}
                <th className="text-left" style={{ width: "100px" }}>
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {orgDesignationList?.map((data, index) => (
                <tr key={index}>
                  {editIndex === index ? (
                    <>
                      <td>
                        <input
                          type="text"
                          value={data.Designation}
                          onChange={handleChange(index, "Designation")}
                          placeholder="Designation"
                          className={`form-control ${errors[`${index}-Designation`] ? "is-invalid" : ""
                            }`}
                        />
                        {errors[`${index}-Designation`] && (
                          <div className="invalid-feedback">
                            {errors[`${index}-Designation`]}
                          </div>
                        )}
                      </td>
                      <td>
                        <input
                        type="text"
                          value={data.DesignationDescription}
                          onChange={handleChange(index, "DesignationDescription")}
                          placeholder="Designation Description"
                          className={`form-control ${errors[`${index}-DesignationDescription`] ? "is-invalid" : ""
                            }`}
                        />
                        {errors[`${index}-DesignationDescription`] && (
                          <div className="invalid-feedback">
                            {errors[`${index}-DesignationDescription`]}
                          </div>
                        )}
                      </td>
                      <td>
                        <>
                          <img
                            onClick={() => {
                              cancelOrgWfh();
                            }}
                            src="/images/org-img/profile/close.png"
                            title="Cancel"
                            className="editactions me-2"
                            style={{ width: "17px" }}
                          />
                          <img
                            onClick={() => {
                              if (validateOrgDesignation(data, index)) {
                                addOrgDesignations(index, data);
                              }
                            }}
                            src="/images/org-img/profile/check.png"
                            title="Confirm"
                            className="editactions"
                            style={{ width: "17px" }}
                          />
                        </>
                      </td>
                    </>
                  ) : (
                    <>
                      <td>{data?.Designation}</td>
                      <td>{data?.DesignationDescription}</td>
                      <td className="">
                        <button
                          disabled={editIndex != null}
                          className="editactions me-2"
                          onClick={() => handleEditClick(index)}
                        >
                          <img
                            src="/images/tickets/edit-ico.svg"
                            className=""
                            title="Edit"
                          />
                        </button>
                        <button
                          className="editactions"
                          title="Delete"
                          data-bs-toggle="modal"
                          data-bs-target="#delete-org-designation"
                          onClick={() => {
                            handleDepartIstDelete(data?.Id);
                          }}
                        >
                          <img
                            src="/images/tickets/delete.svg"
                            className=""
                            title="Delete"
                          />
                        </button>
                      </td>
                    </>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="modal fade " id="delete-org-designation">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content delete-holiday">
              <div className="modal-header">
                <img
                  src="/images/org-img/leave/popup-backimg.png"
                  className="backimg"
                />
                <div className="img">
                  <img src="/images/org-img/leave/trash.png" />
                </div>
              </div>
              <div className="modal-body text-center">
                <strong className="modal-title">Are you sure?</strong>
                {/* <p>{deleteContent}</p> */}
                <p>Do you really want to delete this Designations?</p>
              </div>
              <div className="modal-footer m-auto">
                <button
                  type="button"
                  className="cancelbtn-click"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="deletebtn-click"
                  data-bs-dismiss="modal"
                  onClick={() => DeleteOrgDesignation()}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default OrgDesignationSetting;